import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "broadcast-master";

const GET_ALL_BROADCAST_MASTER_URL = `${prefix}/all`;
const GET_BROADCAST_MASTER_OPTION_URL = `${prefix}/get-option`;
const CREATE_BROADCAST_MASTER_URL = `${prefix}/create`;

/**
 * @func getAllBroadcast
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getAllBroadcast = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_BROADCAST_MASTER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllBroadcast");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllBroadcast */

/**
 * @func getBroadcastOption
 * @desc get broadcast option
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} broadcast option
 */
export const getBroadcastOption = async signal => {
    try {
        const { data, status } = await axios.get(GET_BROADCAST_MASTER_OPTION_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getBroadcastOption");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getBroadcastOption */

/**
 * @func createBuilding
 * @desc create new broadcast
 * @author jew
 * @param {Object} body - create broadcast body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const createBroadcast = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_BROADCAST_MASTER_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createBroadcast");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createBroadcast */
